import { ReactElement, ReactNode } from 'react'

import { Draggable } from '@hello-pangea/dnd'
import classNames from 'classnames'

import * as styles from './styles.scss'

const draggingStyles = {
    boxShadow: '0 3px 10px rgba(0,0,0,.12)',
    border: '3px solid #fff',
    transition: 'all .15s',
}

interface Props {
    children: ReactNode
    id: string
    index: number
    className?: string | undefined
    isDragDisabled?: boolean
}

const DraggableListItem = ({
    children,
    id,
    index,
    className = undefined,
    isDragDisabled = false,
}: Props): ReactElement => (
    <Draggable draggableId={id} index={index} isDragDisabled={isDragDisabled}>
        {(provided, snapshot) => (
            <div
                className={classNames(styles.item, className)}
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
                style={{
                    ...(snapshot.isDragging ? draggingStyles : {}),
                    ...provided.draggableProps.style,
                }}
            >
                {children}
            </div>
        )}
    </Draggable>
)

export default DraggableListItem
